import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/elctrpt/iqs`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/elctrpt/iqs/iqs-mgmt`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0304003s: `${BASE.path}/ptli0304003s`, // Register for IQSs Management      !== 통합질의(IQS) 등록 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View Child List By ComnCode  !== 공통코드 자식 List 조회 ==!
    selectChildListByComnCd: (data: any) => {
        return api.post(`${BASE.api}/code`, {
            ...data,
        });
    },
    saveIQSInfo : (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    
    // View role information  !== 역할 정보 조회 ==!
    getIqs: (id: any) => api.get(`${BASE.api}/${id}`),
};

const iqsSbjctlTpCdListArr = [
    { label: "Text", value: "T" }
    , { label: "ComnCode", value: "C" }
]

export const SF_IQS_FORM_MAKE: TFormSchema = {
    id: "form_iqsFormMake",
    schema: {
        comnCd: { type: "text", label: "L_USER_TP_CD" },
        trgtList: { type: "text", label: "L_USR_ID" },
        docCdVal : { label:"L_DOC_CD" ,type: "code", area: "comnCd", comnCd: "CGM0001", required: true},
        trgtDispYn: { type: "radio", label: "L_TRGT_DISP_YN", options: [
            { label: "Y", value: "Y" }
            , { label: "N", value: "N" }
        ], defaultValue : "Y"  },
    },
};

export const SG_IQS_FORM_MAKE: TGridSchema = {
    id: "grid_iqsFormMake",
    options: { edit: true, index: true, checkbox:true, height:300},
    head: [
        { cells: [{ header: "L_SBJCTL_LBL_NM", binding: "iqsSbjctlLblNm", required:true, width: "*" }] },
        { cells: [{ header: "L_INIT_VALUE", binding: "defaultValue", width: "20%" }] },
        { cells: [{ header: "L_INP_TP_CD", binding: "iqsSbjctlTpCd", required:true, width: "15%" }] },
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: "15%" }] },
        { cells: [{ header: "L_EDIT_YN", binding: "editable", width: "15%" }] },
        { cells: [{ header: "L_RQRD_YN", binding: "required", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "iqsSbjctlLblNm", type: "text", align: "left" }] },
        { cells: [{ binding: "defaultValue", type: "text", align: "left" }] },
        { cells: [{ binding: "iqsSbjctlTpCd", type: "select", options: iqsSbjctlTpCdListArr, align: "left" }] },
        { cells: [{ binding: "comnCd", type: "text", align: "left" }] },
        { cells: [{ binding: "editable", type : "radio", align: "center",options :[{ label: "Y", value: "true" },{ label: "N", value: "false" }] }] },
        { cells: [{ binding: "required", type : "radio", align: "center",options :[{ label: "Y", value: "true" },{ label: "N", value: "false" }] }] },
    ],
};

export const SF_IQS_FORM: TFormSchema = {
    id: "form_iqsForm",
    schema: {
    },
};


